import { Component, Input } from '@angular/core';
import { ServiceSchedule } from '@app/core/api-azure-functions/dataverse-functions';

@Component({
  selector: 'app-service-schedules',
  templateUrl: './service-schedules.component.html',
  styleUrls: ['./service-schedules.component.scss'],
})
export class ServiceSchedulesComponent {
  @Input() serviceSchedules: ServiceSchedule[];
  @Input() isModal = false;

  constructor() {}
}
